import React, { useEffect, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import PaymentCenter from '../components/PaymentCenter';
import ReceiptPage from '../components/ReceiptPage';

const PaymentCenterPage = () => {
  const [receiptData, setReceiptData] = useState(null);
  const [cancelled, setCancelled] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    const status = params.get('status');
    const gateway = params.get('gateway');
    const receiptId = params.get('receipt');

    if (receiptId) {
      setReceiptData({ orderId: receiptId, gateway: gateway || 'fiserv', failed: status === 'failed' });
      window.history.replaceState({}, '', '/payment-center');
    } else if (sessionId && status === 'success') {
      setReceiptData({ orderId: sessionId, gateway: 'stripe', failed: false });
      // Keep Stripe reference in the URL so refresh can restore the receipt.
    } else if (status === 'cancelled') {
      setCancelled(true);
      window.history.replaceState({}, '', '/payment-center');
    } else if (status === 'failed') {
      setReceiptData({ orderId: receiptId || sessionId || '', gateway: gateway || 'unknown', failed: true });
      window.history.replaceState({}, '', '/payment-center');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="payment-center-page">
      <header className="bg-black py-4 px-4 md:px-8">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 text-white/70 hover:text-white text-sm transition-colors" data-testid="back-to-home">
            <ArrowLeft className="w-4 h-4" />
            <span className="tracking-wide">Back to Home</span>
          </a>
          <img src="/logos/sag-logo.png" alt="Sebastian Alliance Group" className="h-8 w-auto" />
        </div>
      </header>

      {cancelled && (
        <div className="bg-slate-50 border-b border-slate-200 py-4 px-4 text-center">
          <p className="text-slate-500 text-sm">Payment was cancelled. You can try again below.</p>
        </div>
      )}

      {!receiptData && <PaymentCenter />}

      {receiptData && (
        <ReceiptPage
          orderId={receiptData.orderId}
          gateway={receiptData.gateway}
          failed={receiptData.failed}
          onClose={() => setReceiptData(null)}
        />
      )}

      <footer className="bg-black py-6 px-4 text-center">
        <p className="text-white/40 text-xs tracking-wider">Sebastian Alliance Group &bull; Secure Payment Processing</p>
      </footer>
    </div>
  );
};

export default PaymentCenterPage;
